import { api } from '@/api'
import { Period } from '@/ui-kit'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export function useFetchUserJobs(period: Period): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    queryKey: ['useFetchUserJobs', period],
    queryFn: () => api.get(`/user/stats/jobs?period=${period}`),
    retry: 0
  })
}
